import * as React from 'react';
import * as fabric from './Fabric';
import * as Strings from './Strings';
import notify from '../../shared/feedback/notifications';
import * as AnnotationTypes from './AnnotationTypes';
import { AnnotationTexts } from './AnnotationTypes';
import * as revisionTypes from '../../components/common/planOrder/RevisionType';
import * as Features from '../../shared/Features';
import { LocalDateTime } from '../localDate/DateTimeView';
import { handleError } from '../../shared/ErrorCatching';
import { IBooleanWrapper, IFile, IObjectWrapper, IStringWrapper } from './Types';
import { assign } from '../../shared/Assign';
import { Translate } from '../../shared/LanguageService';
import { Button, Col, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import PlanAnnotationToolbar from './PlanAnnotationToolbar';
import PlanAnnotationDisplay from './PlanAnnotationDisplay';
import PlanAnnotationSaveReset from './PlanAnnotationSaveReset';
import PlanAnnotationDragSourcePanel from './PlanAnnotationDragSourcePanel';
import PlanAnnotationTextPanel from './PlanAnnotationTextPanel';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import FormSelect from '../../components/common/FormSelect';
import CustomerMessages from '../../components/common/planOrder/CustomerMessages';
import { UserRole } from '../../shared/types';
import Loader from 'react-loader';

interface IProps {
    save: (
        id: number,
        data: string,
        revisionType: number,
        annotationType: string,
        hasDoneCrop?: boolean,
        hasDoneFlip?: boolean
    ) => any;
    annotation: {
        original: IFile;
        subject: IFile;
        revisions: { reference: string; name: string }[];
        planOrderStoreyFiles: any[];
        globalFontSize?: number;
        fontSizeRatio: number;
    };
    storeys: any[];
    type: string;
    user: any;
    address: string;
    commonTexts?: string[];
    fontFamily?: string;
    upperCase?: boolean;
    fontSizeRatio?: number | null;
    close?: () => void;
    changeFile?: (id: number) => void;
    showFilePlacementsModal?: (planOrderStoreyFileId) => void;
    byCustomer?: boolean;
    extraInformation?: string;
    returnedMessages?: {
        returnedMessage: string;
        returnedDate: LocalDateTime;
    }[];
}

class PlanAnnotationTool extends React.Component<IProps, any> {
    canvasId = 'annotationCanvas';
    listId = 'text-list';

    private _fabric: any;
    private _canvas: any;
    private _canvasContainer: any;
    private _mouseIsDown: any = null;
    private _isCropping: IBooleanWrapper = { value: false };
    private _isDrawing: IBooleanWrapper = { value: false };
    private _isDrawingEllipse: IBooleanWrapper = { value: false };
    private _isDrawingRectangle: IBooleanWrapper = { value: false };
    private _isRotateFreely: IBooleanWrapper = { value: false };
    private _isColorPipette: IBooleanWrapper = { value: false };
    private _selectedStorey: IObjectWrapper = { value: null };
    private _comment: IStringWrapper = { value: '' };
    private _hadDoneCrop: boolean = false;
    private _hadDoneFlip: boolean = false;
    private _isMounted: boolean = false;
    private _isEditingText: boolean = false;
    private _allowDuplication: boolean = true;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: true,
            hasConfiguredSymbolEvents: false,
            showModal: false,
            isDrawing: false,
            isDrawingEllipse: false,
            isDrawingRectangle: false,
            isCropping: false,
            isRotateFreely: false,
            isGridActive: false,
            comment: '',
            storey: 0,
            customStorey: { text: '' },
            storeyIsSelected: false,
            canvasKey: 0,
            fontSize: 32,
            isObjectSelected: false,
            strokeWidth: 5,
            strokeColor: { r: 255, g: 0, b: 0, a: 1 },
            showColorPicker: false,
            isColorPipette: false,
            showCloseConfirmation: false,
            saveCallback: null,
            canvasHasChanged: false,
            showDeleteAllObjectsExceptTextsConfirmation: false,
            fontSizeRatio: 1
        };

        this.levelChange = this.levelChange.bind(this);
        this.setCanvasContainerReference = this.setCanvasContainerReference.bind(this);
        this.flipHorizontal = this.flipHorizontal.bind(this);
        this.flipVertical = this.flipVertical.bind(this);
        this.rotate = this.rotate.bind(this);
        this.handleToolbarChanges = this.handleToolbarChanges.bind(this);
        this.crop = this.crop.bind(this);
        this.handleDropped = this.handleDropped.bind(this);
        this.handleCommentDropped = this.handleCommentDropped.bind(this);
        this.handleStoreyDeselected = this.handleStoreyDeselected.bind(this);
        this.reset = this.reset.bind(this);
        this.save = this.save.bind(this);
        this.handleSelectedObject = this.handleSelectedObject.bind(this);
        this.handleDeselectedObject = this.handleDeselectedObject.bind(this);
        this.windowResize = this.windowResize.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onToolbarFontSizeChange = this.onToolbarFontSizeChange.bind(this);
        this.onToolbarDeleteObject = this.onToolbarDeleteObject.bind(this);
        this.onToolbarDeleteAllObjectsExceptTexts =
            this.onToolbarDeleteAllObjectsExceptTexts.bind(this);
        this.showDeleteAllObjectsExceptTextsConfirmation =
            this.showDeleteAllObjectsExceptTextsConfirmation.bind(this);
        this.onToolbarStrokeWidthChange = this.onToolbarStrokeWidthChange.bind(this);
        this.onToolbarStrokeColorChange = this.onToolbarStrokeColorChange.bind(this);
        this.onShowColorPickerChanged = this.onShowColorPickerChanged.bind(this);
        this.deactivateColorPipette = this.deactivateColorPipette.bind(this);
        this.deactivateCheckboxes = this.deactivateCheckboxes.bind(this);
        this.firstRenderCallback = this.firstRenderCallback.bind(this);
        this.onHideModal = this.onHideModal.bind(this);
        this.onCanvasHasChanged = this.onCanvasHasChanged.bind(this);
        this.canSave = this.canSave.bind(this);
        this.rotate = this.rotate.bind(this);
        this.openImage = this.openImage.bind(this);
        this.onPlanOrderStoreyFileChanged = this.onPlanOrderStoreyFileChanged.bind(this);
        this.toggleRotate = this.toggleRotate.bind(this);
        this.saveMultipleCrop = this.saveMultipleCrop.bind(this);
        this.toggleGrid = this.toggleGrid.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setEditingTextState = this.setEditingTextState.bind(this);
        this.restoreCanvasPosition = this.restoreCanvasPosition.bind(this);
        this.zoom = this.zoom.bind(this);
        this.allowedToPan = this.allowedToPan.bind(this);
    }

    componentDidMount(): void {
        this._isMounted = true;
        this._fabric = fabric.constructFabric();

        this.setState(
            {
                annotation: this.props.annotation,
                fontSize: this.props.annotation.globalFontSize
                    ? this.props.annotation.globalFontSize
                    : this.state.fontSize,
                fontSizeRatio: this.props.annotation.fontSizeRatio
            },
            () => {
                // The timeout is because of render bug in edge
                setTimeout(() => {
                    window.addEventListener('resize', this.windowResize);
                    window.addEventListener('keydown', this.onKeyDown);
                    window.addEventListener('keyup', this.onKeyUp);
                    this.updateComponent(
                        this.state.annotation.original,
                        this.state.annotation.subject
                    );
                }, 0);
            }
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        if (JSON.stringify(this.state.annotation) !== JSON.stringify(nextProps.annotation)) {
            this._isMounted = false;
            this._canvasContainer = null;
            this._hadDoneCrop = false;

            if (this._canvas) {
                this._canvas.clear();
                this._canvas = null;
            }

            this.setState(
                {
                    hasConfiguredSymbolEvents: false,
                    annotation: nextProps.annotation,
                    showCloseConfirmation: false,
                    saveCallback: null,
                    canvasHasChanged: false,
                    fontSizeRatio: nextProps.annotation.fontSizeRatio
                },
                () => {
                    setTimeout(() => {
                        this._isMounted = true;
                        this.updateComponent(
                            this.state.annotation.original,
                            this.state.annotation.subject
                        );
                    }, 0);
                }
            );
        }

        if (nextProps.annotation && nextProps.fontSizeRatio) {
            if (nextProps.annotation.fontSizeRatio !== nextProps.fontSizeRatio) {
                this.setState({ fontSizeRatio: nextProps.fontSizeRatio }, () => {
                    this.onToolbarFontSizeChange(this.state.fontSize);
                });
            }
        }
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        window.removeEventListener('resize', this.windowResize);
        window.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('keyup', this.onKeyUp);
    }

    componentDidUpdate(): void {
        if (this._isMounted && this.state.annotation) {
            this.updateComponent(this.state.annotation.original, this.state.annotation.subject);
        }
    }

    updateComponent(original, subject) {
        if (!document.getElementById(this.canvasId + subject.id)) {
            return;
        }

        const { apiUrl } = window.appConfig;

        if (!this._canvas && this._canvasContainer) {
            this._canvas = fabric.constructCanvasWithImage(
                this._fabric,
                this._mouseIsDown,
                this._isCropping,
                this._isDrawing,
                this._isDrawingEllipse,
                this._isDrawingRectangle,
                this._selectedStorey,
                this.canvasId + subject.id,
                `${apiUrl}/file/${original.reference}`,
                this.handleStoreyDeselected,
                assign({}, subject).canvasContent,
                this.props.fontFamily,
                this.state.fontSize,
                this.props.annotation.fontSizeRatio,
                this.props.upperCase,
                this.handleSelectedObject,
                this.handleDeselectedObject,
                this.state.strokeWidth,
                this.state.strokeColor,
                this._isColorPipette,
                this.onToolbarStrokeColorChange,
                this.deactivateColorPipette,
                this.onCanvasHasChanged,
                this.props.type,
                this.setEditingTextState,
                this.props.type === AnnotationTypes.AnnotationTexts,
                this.allowedToPan,
                this.firstRenderCallback
            );
            this.forceUpdate();
        } else if (!this.state.hasConfiguredSymbolEvents) {
            fabric.configureDraggingEvents(
                this._fabric,
                this._canvas,
                this._canvasContainer,
                this.handleDropped,
                this.handleCommentDropped,
                this.props.type === AnnotationTypes.AnnotationTexts,
                this.setEditingTextState
            );
            this.setState({ hasConfiguredSymbolEvents: true });
        }
    }

    firstRenderCallback(): boolean {
        if (this._canvas) {
            this.levelChange();

            if (
                this.props.type === AnnotationTypes.AnnotationNormal ||
                this.props.type === AnnotationTypes.AnnotationTexts ||
                this.props.type === AnnotationTypes.ExternalAnnotation ||
                this.props.type === AnnotationTypes.DeliveryAnnotation ||
                this.props.type === AnnotationTypes.ExternalDeliveryAnnotation
            ) {
                let texts = this._canvas.getObjects().filter((x) => x.type === 'textbox');

                if (
                    this.props.type === AnnotationTypes.AnnotationNormal ||
                    this.props.type === AnnotationTypes.ExternalAnnotation ||
                    this.props.type === AnnotationTypes.DeliveryAnnotation ||
                    this.props.type === AnnotationTypes.ExternalDeliveryAnnotation
                ) {
                    texts = texts.filter((x) => x.isComment);
                }

                if (texts.length > 0 && !this.props.annotation.globalFontSize) {
                    this.onToolbarFontSizeChange(texts[0].fontSize, false);
                }
            } else if (this.props.type === AnnotationTypes.AnnotationFloorCrop) {
                this._canvas.forEachObject(function (o) {
                    o.selectable = false;
                });
            }

            this.setState({ isLoading: false });
            return this.windowResize();
        }

        return false;
    }

    levelChange(): void {
        fabric.configureDraggingEvents(
            this._fabric,
            this._canvas,
            this._canvasContainer,
            this.handleDropped,
            this.handleCommentDropped,
            this.props.type === AnnotationTypes.AnnotationTexts,
            this.setEditingTextState
        );
    }

    setCanvasContainerReference(node: any): void {
        if (node) {
            this._canvasContainer = node;
        }
    }

    flipHorizontal(e: any): void {
        fabric.flipHorizontal(this._fabric, this._canvas);
        this._hadDoneFlip = true;
        this.setState({ canvasHasChanged: true });
    }

    flipVertical(e: any): void {
        fabric.flipVertical(this._fabric, this._canvas);
        this._hadDoneFlip = true;
        this.setState({ canvasHasChanged: true });
    }

    rotate(angle: number): void {
        fabric.rotate(
            this._fabric,
            this._canvas,
            this._canvasContainer.parentElement.offsetWidth,
            angle
        );
        this.setState({ canvasHasChanged: true });
    }

    handleToolbarChanges(name: string, value: any = null, checked: boolean = false): void {
        switch (name) {
            case Strings.drawToolCheckboxName:
                this._canvas.discardActiveObject();
                let isDrawing = this.state.isDrawing;
                this.deactivateCheckboxes();
                this._isDrawing.value = !isDrawing;

                fabric.toggleDrawing(this._canvas, checked);
                this.setState({
                    isDrawing: !isDrawing,
                    objectsHasBeenPlaced: fabric.areAnyObjectsPlaced(this._canvas)
                });
                break;

            case Strings.drawEllipseToolCheckboxName:
                this._canvas.discardActiveObject();
                let isDrawingEllipse = this._isDrawingEllipse.value;
                this.deactivateCheckboxes();

                this._isDrawingEllipse.value = !isDrawingEllipse;
                this.setSelectableOnObjects(false);

                this.setState({
                    isDrawingEllipse: !isDrawingEllipse,
                    objectsHasBeenPlaced: fabric.areAnyObjectsPlaced(this._canvas)
                });
                break;
            case Strings.drawRectangleToolCheckboxName:
                this._canvas.discardActiveObject();
                let isDrawingRectangle = this._isDrawingRectangle.value;
                this.deactivateCheckboxes();

                this._isDrawingRectangle.value = !isDrawingRectangle;
                this.setSelectableOnObjects(false);

                this.setState({
                    isDrawingRectangle: !isDrawingRectangle,
                    objectsHasBeenPlaced: fabric.areAnyObjectsPlaced(this._canvas)
                });
                break;

            case Strings.cropToolCheckboxName:
                this._canvas.discardActiveObject();
                let isCropping = !this._isCropping.value;
                this.deactivateCheckboxes();
                this._isCropping.value = isCropping;
                this.setState({ isCropping: isCropping });
                if (isCropping) {
                    this.setSelectableOnObjects(false);
                    this._canvas.renderAll();
                    fabric.toggleCrop(true, this._fabric, this._canvas);
                }
                break;
            case Strings.commentToolTextAreaName:
                this._canvas.discardActiveObject();
                this.setState({ comment: value });
                this._comment.value = value;
                break;

            case Strings.fontSizeToolChange:
                this.onToolbarFontSizeChange(value);
                break;

            case Strings.strokeWidthToolChange:
                this.onToolbarStrokeWidthChange(parseInt(value));
                break;
            case Strings.colorPipetteToolCheckboxName:
                let isColorPipette = this._isColorPipette.value;
                this.deactivateCheckboxes();
                this._isColorPipette.value = !isColorPipette;
                this.setState({ isColorPipette: !isColorPipette });
                break;
            case Strings.rotateFreelyName:
                this._canvas.discardActiveObject();
                this.toggleRotate();
                break;
        }

        if (
            !this._isDrawingEllipse.value &&
            !this._isDrawingRectangle.value &&
            !this._isCropping.value
        ) {
            this.setSelectableOnObjects(true);
        }

        this._canvas.renderAll();
    }

    toggleRotate() {
        let newState = !this._isRotateFreely.value;
        this.deactivateCheckboxes();
        this._isRotateFreely.value = newState;
        this.setState({ isRotateFreely: newState });
        fabric.toggleRotateFreely(
            newState,
            this._fabric,
            this._canvas,
            this._canvasContainer.parentElement.offsetWidth,
            this.props.type === AnnotationTypes.AnnotationTexts ? 90 : null
        );
        if (newState) {
            this.toggleGrid(true);
        }
    }

    toggleGrid(state?: boolean) {
        if (this.state.isGridActive || state === false) {
            fabric.resetGridImage();
        } else {
            fabric.setGridImage();
        }
        this.setState({ isGridActive: !this.state.isGridActive });
    }

    deactivateCheckboxes() {
        if (this._isCropping.value) {
            fabric.toggleCrop(false, this._fabric, this._canvas);
        }

        this._isCropping.value = false;
        this._isDrawing.value = false;
        this._isDrawingEllipse.value = false;
        this._isDrawingRectangle.value = false;
        this._isColorPipette.value = false;
        this._isRotateFreely.value = false;

        fabric.toggleDrawing(this._canvas, false);

        this.setSelectableOnObjects(true);

        this.setState({
            isDrawing: false,
            isDrawingEllipse: false,
            isDrawingRectangle: false,
            isColorPipette: false,
            isCropping: false,
            isRotateFreely: false,
            isGridActive: false
        });
    }

    setSelectableOnObjects(selectable: boolean) {
        let objects = this._canvas.getObjects();
        for (let i = 1; i < objects.length; i++) {
            let o = objects[i];
            o.selectable = selectable;

            if (
                (this.props.type === AnnotationTypes.AnnotationNormal ||
                    this.props.type === AnnotationTypes.ExternalAnnotation ||
                    this.props.type === AnnotationTypes.DeliveryAnnotation ||
                    this.props.type === AnnotationTypes.ExternalDeliveryAnnotation) &&
                o.type === 'textbox' &&
                !o.isComment
            ) {
                o.selectable = false;
            }
        }
    }

    restoreCanvasPosition() {
        fabric.restoreCanvasPosition(this._canvas);
        this.setState({ canvasHasMoved: false });
    }

    onToolbarFontSizeChange(size: number, hasChanged: boolean = true): void {
        if (size > 0 && this._canvas) {
            this.setState({ fontSize: size, canvasHasChanged: hasChanged });

            this._canvas.fontSize = size * this.state.fontSizeRatio;
            fabric.fontSizeChange(
                this._canvas,
                this.props.type,
                !hasChanged /* disable auto width when loading comments */
            );
        }

        if (!size && this._canvas) {
            this.setState({ fontSize: '', canvasHasChanged: hasChanged });

            this._canvas.fontSize = 1 * this.state.fontSizeRatio;
            fabric.fontSizeChange(
                this._canvas,
                this.props.type,
                !hasChanged /* disable auto width when loading comments */
            );
        }
    }

    onToolbarStrokeWidthChange(width: number): void {
        width = Math.max(1, Math.min(width, 30));
        this._canvas.freeDrawingBrush.width = width;
        fabric.strokeWidthChange(width);
        this.setState({ strokeWidth: width });
    }

    onToolbarStrokeColorChange(rgb: any): void {
        let color = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
        this._canvas.freeDrawingBrush.color = color;
        fabric.strokeColorChange(rgb);
        this.setState({
            strokeColor: { r: rgb.r, g: rgb.g, b: rgb.b, a: rgb.a }
        });
    }

    deactivateColorPipette() {
        this._isColorPipette.value = false;
        this.setState({ isColorPipette: false });
    }

    onShowColorPickerChanged() {
        this.deactivateColorPipette();
        this.setState({ showColorPicker: !this.state.showColorPicker });
    }

    onToolbarDeleteObject(e: any): void {
        fabric.deleteObjects(this._canvas);
        this.handleDeselectedObject();
    }

    showDeleteAllObjectsExceptTextsConfirmation() {
        this.setState({ showDeleteAllObjectsExceptTextsConfirmation: true });
    }

    onToolbarDeleteAllObjectsExceptTexts(): void {
        fabric.deleteAllObjectsExceptsTexts(this._canvas);
        this.handleDeselectedObject();
        this.setState({ showDeleteAllObjectsExceptTextsConfirmation: false });
    }

    crop(e: any): void {
        fabric.crop(this._fabric, this._canvas, this._canvasContainer.parentElement.offsetWidth);

        this.setState({ isCropping: false });
        this._isCropping.value = false;
        this._hadDoneCrop = true;
    }

    handleCommentDropped(): void {
        this._comment.value = '';
        this.setState({
            isCommenting: false,
            comment: ''
        });
    }

    handleDropped(): void {
        this.deactivateCheckboxes();
    }

    handleStoreyDeselected(): void {
        this.setState({
            storeyIsSelected: false,
            storey: 0,
            customStorey: assign({}, { text: '' })
        });
    }

    reset(): void {
        let { apiUrl } = window.appConfig;

        this.deactivateCheckboxes();
        this._canvas.clear();
        let canvasContent = assign({}, this.state.annotation.subject).canvasContent;
        fabric.reset(
            this._fabric,
            this._canvas,
            canvasContent,
            `${apiUrl}/file/${this.state.annotation.original.reference}`,
            this.props.type,
            this.state.fontSizeRatio ? this.state.fontSize * this.state.fontSizeRatio : null
        );
        if (this.state.isGridActive) {
            fabric.resetGridImage();
        }
    }

    saveAnnotationTexts = (revisionType: number, callback: () => void): void => {
        let saveData: any = {
            canvasContent: fabric.getSaveData(this._fabric, this._canvas),
            isAdvanced: false,
            fontSize: this.state.fontSize
        };

        this.props
            .save(
                this.props.annotation.original.id,
                saveData,
                revisionType,
                AnnotationTexts,
                this._hadDoneCrop
            )
            .then(() => {
                notify.success(Translate('plans/annotation/notifications/successful-save'));

                if (this._isMounted) {
                    this.setState({ isSaving: false }, () => {
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    });

                    if (!callback && this.props.close) {
                        this.props.close();
                    }
                }
            })
            .catch((error: any) => {
                handleError(error);
                this.setState({ isSaving: false });
            });
    };

    save(callback?: () => void): void {
        this.setState({ isSaving: true }, () => {
            fabric.restoreZoom(this._canvas);
            switch (this.props.type) {
                case AnnotationTypes.AnnotationTexts:
                    let revisionType = revisionTypes.editTexts;
                    this.setSelectableOnObjects(true);

                    fabric.trimAndResizeTexts(this._canvas);

                    this._canvas.discardActiveObject();

                    this._canvas.on('after:render', (e) => {
                        this._canvas.off('after:render');
                        this.saveAnnotationTexts(revisionType, callback);
                    });

                    this._canvas.renderAll();
                    break;

                case AnnotationTypes.ExternalAnnotation:
                case AnnotationTypes.AnnotationNormal:
                case AnnotationTypes.DeliveryAnnotation:
                case AnnotationTypes.ExternalDeliveryAnnotation:
                    if (this._canvas.getObjects().some((x) => x.id === 'cropRect')) {
                        let annotatingExternal =
                            this.props.type === AnnotationTypes.ExternalAnnotation;
                        if (annotatingExternal || this.props.byCustomer) {
                            this.saveMultipleCrop(
                                true,
                                annotatingExternal,
                                this.props.byCustomer,
                                callback
                            );
                        } else if (
                            (this.props.type === AnnotationTypes.DeliveryAnnotation ||
                                this.props.type === AnnotationTypes.ExternalDeliveryAnnotation) &&
                            this.props.byCustomer
                        ) {
                            notify.failure(
                                Translate('plan/annotation/delivery-file/customer-errors/crop')
                            );
                            this.props.close();
                        } else {
                            this.saveMultipleCrop(false, false, false, callback);
                        }
                    } else {
                        this.setSelectableOnObjects(true);

                        this._canvas.discardActiveObject();
                        this._canvas.renderAll();

                        let saveDataNormal: any = {
                            canvasContent: fabric.getSaveData(this._fabric, this._canvas),
                            isAdvanced: true
                        };

                        let image = this._canvas.getObjects()[0];
                        let boundRectImage = image.getBoundingRect();
                        let data = this._canvas.toDataURL({
                            left: boundRectImage.left,
                            top: boundRectImage.top,
                            width: boundRectImage.width,
                            height: boundRectImage.height,
                            format: 'jpeg'
                        });

                        if (this._hadDoneCrop) {
                            let imageData = fabric.getCropDataUrl();
                            let originalFile: any = fabric.dataURLtoBlob(imageData);
                            originalFile.name = this.state.annotation.original.filename;
                            saveDataNormal.originalUpload = [originalFile];
                        }

                        let file: any = fabric.dataURLtoBlob(data);
                        file.name = this.state.annotation.original.filename;

                        saveDataNormal.upload = [file];
                        let id =
                            this.props.type === AnnotationTypes.ExternalAnnotation ||
                            this.props.type === AnnotationTypes.ExternalDeliveryAnnotation
                                ? this.state.annotation.subject.id
                                : this.state.annotation.original.id;
                        this.props
                            .save(
                                id,
                                saveDataNormal,
                                revisionTypes.annotation,
                                this.props.type,
                                this._hadDoneCrop,
                                this._hadDoneFlip
                            )
                            .then(() => {
                                notify.success(
                                    Translate('plans/annotation/notifications/successful-save')
                                );

                                if (this._isMounted) {
                                    this.setState({ isSaving: false }, () => {
                                        if (callback && typeof callback === 'function') {
                                            callback();
                                        }
                                    });

                                    if (!callback && this.props.close) {
                                        this.props.close();
                                    }
                                }
                            })
                            .catch((error: any) => {
                                handleError(error);
                                this.setState({ isSaving: false });
                            });
                    }
                    break;
                case AnnotationTypes.AnnotationFloorCrop:
                    this.saveMultipleCrop(false, false, this.props.byCustomer, callback);
                    break;
                default:
                    this.setState({ isSaving: false });
                    break;
            }
        });
    }

    saveMultipleCrop(
        limitToOne: boolean,
        annotatingExternal: boolean,
        byCustomer: boolean,
        callback?: () => void
    ) {
        fabric
            .cropMutiple(this._fabric, this._canvas, this._canvasContainer.parentElement)
            .then((files) => {
                if (limitToOne && files.length > 1) {
                    this.setState({ isSaving: false }, () => {
                        if (byCustomer) {
                            notify.failure(
                                Translate('plan/annotation/external-file/customer-errors/crops')
                            );
                        } else {
                            notify.failure(Translate('plan/annotation/external-file/errors/crops'));
                        }
                    });
                    return;
                }

                let dataFiles = files.map((x) => {
                    let imageData = x.image.toDataURL({ format: 'jpeg' });
                    let file: any = fabric.dataURLtoBlob(imageData);
                    file.name = this.state.annotation.original.filename;

                    let data = {
                        upload: [file],
                        canvasContent: null,
                        revisionUpload: null
                    };

                    if (x.objects && x.objects.length > 0) {
                        let tempCanvas = new this._fabric.Canvas();
                        tempCanvas.width = x.image.width;
                        tempCanvas.height = x.image.height;
                        tempCanvas.setWidth(x.image.width);
                        tempCanvas.setHeight(x.image.height);
                        tempCanvas.add(x.image);
                        x.objects.forEach((o) => {
                            tempCanvas.add(o);
                        });

                        let cropData = tempCanvas.toDataURL({ format: 'jpeg' });
                        let canvasFile: any = fabric.dataURLtoBlob(cropData);
                        canvasFile.name = this.state.annotation.original.filename;
                        data.revisionUpload = [canvasFile];

                        data.canvasContent = fabric.getSaveData(this._fabric, tempCanvas);
                    }

                    return data;
                });

                dataFiles
                    .map((x: any, index: number) => {
                        if (index === 0) {
                            x.originalUpload = x.upload;
                            x.upload = x.revisionUpload;
                            delete x.revisionUpload;
                        }

                        let annotationType = annotatingExternal
                            ? AnnotationTypes.ExternalAnnotation
                            : index === 0
                            ? AnnotationTypes.AnnotationNormal
                            : AnnotationTypes.AnnotationFloorCrop;
                        return () =>
                            this.props
                                .save(
                                    this.state.annotation.original.id,
                                    x,
                                    revisionTypes.annotation,
                                    annotationType,
                                    true
                                )
                                .catch((error: any) => handleError(error));
                    })
                    .reduce(
                        (promiseChain, current) => promiseChain.then(current),
                        Promise.resolve()
                    )
                    .then(() => {
                        notify.success(
                            Translate('plans/annotation/notifications/floor-successful-save')
                        );

                        if (this._isMounted) {
                            this.setState({ isSaving: false }, () => {
                                if (callback && typeof callback === 'function') {
                                    callback();
                                }
                            });

                            if (!callback && this.props.close) {
                                this.props.close();
                            }
                        }
                    })
                    .catch((error: any) => {
                        this.setState({ isSaving: false });
                    });
            });
    }

    handleSelectedObject() {
        this.setState({
            isObjectSelected: true
        });
    }

    handleDeselectedObject() {
        this.setState({
            isObjectSelected: false
        });
    }

    windowResize(): boolean {
        if (this._canvas) {
            if (this.state.isRotateFreely) {
                this.toggleRotate();
            }
            return fabric.canvasResize(
                this._fabric,
                this._canvas,
                this._canvasContainer.parentElement.offsetWidth
            );
        }

        return false;
    }

    onCanvasHasChanged(isSymbol: boolean = false) {
        if (!this.state.canvasHasChanged) {
            this.setState({ canvasHasChanged: true });
        }

        if (isSymbol === true) {
            this.deactivateCheckboxes();
        }
    }

    onHideModal(callback?: () => void) {
        if (this.state.canvasHasChanged || this._hadDoneCrop) {
            this.setState({
                showCloseConfirmation: true,
                saveCallback: callback
            });
        } else {
            callback ? callback() : this.props.close();
        }
    }

    canSave() {
        return this.state.isRotateFreely === false || this.state.isSaving;
    }

    openImage(e: any) {
        /* TODO: Setting window size this way is not an elegant solution, maybe it can be done better with css */
        const { apiUrl } = window.appConfig;

        let revision = this.state.annotation.revisions[e.target.value];
        let url = `${apiUrl}/file/${revision.reference}`; // '/api/file/' + revision.reference;
        let style = ' body { max-width:1500px; background-color: gainsboro; }';
        style += ' a{ }';
        style += ' a img {     max-width:100%; max-height:100vh; }';
        let newWindow = window.open(
            '',
            'pictureViewer',
            'location=no, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, resizable=yes, width=800, height=800'
        );
        newWindow.document.writeln('<html>');
        newWindow.document.writeln('<head>');
        newWindow.document.writeln(`<title>${revision.name}</title>`);
        newWindow.document.writeln(`<style>${style}</style>`);
        newWindow.document.writeln('</head>');
        newWindow.document.writeln("<body style='margin: 0 0 0 0;'>");
        newWindow.document.writeln(
            `<a title='${Translate(
                'plan-annotation/modal/compare/window/hover'
            )}' href='javascript:window.close();'>`
        );
        newWindow.document.writeln(
            `<img src='${url}' alt='${Translate(
                'plan-annotation/modal/compare/window/hover'
            )}' id='image'/>`
        );
        newWindow.document.writeln('</a>');
        newWindow.document.writeln('</body></html>');
        newWindow.document.close();
    }

    onPlanOrderStoreyFileChanged(id: number) {
        this.onHideModal(() => {
            this.setState({ isLoading: true, saveCallback: null });
            this.props.changeFile(id);
        });
    }

    containsEditedFile(storeyId: number, storeyFiles: any[]): boolean {
        let containsFile = false;
        storeyFiles.forEach((x) => {
            if (x.planOrderStoreyId === storeyId && x.fileType > 1) {
                containsFile = true;
            }
        });
        return containsFile;
    }

    filterOutBlueprints(propType: string, storeyFiles: any[]) {
        return storeyFiles.filter(
            (x) =>
                (propType === AnnotationTypes.AnnotationTexts && x.filetype > 1) ||
                (x.fileType === 1 && !this.containsEditedFile(x.planOrderStoreyId, storeyFiles)) ||
                x.fileType !== 1
        );
    }

    setEditingTextState(isEditingText: boolean) {
        this._isEditingText = isEditingText;
    }

    zoom(zoomAmount: number) {
        fabric.zoom(zoomAmount, this._canvas);
    }

    allowedToPan(): boolean {
        const { isCropping, isDrawing, isDrawingEllipse, isDrawingRectangle, isObjectSelected } =
            this.state;

        return !(
            isCropping ||
            isDrawing ||
            isDrawingEllipse ||
            isDrawingRectangle ||
            isObjectSelected
        );
    }

    allowedTextCharacter(key: any): boolean {
        // Check if (extended) ascii value
        return /^[\x00-\xFF]/.test(key);
    }

    onKeyDown(e: any): void {
        const key = e.key.toLowerCase();

        if (
            this.props.type === AnnotationTypes.AnnotationTexts &&
            this._isEditingText &&
            !this.allowedTextCharacter(key)
        ) {
            e.preventDefault();
            return;
        }

        if (this.props.type === AnnotationTypes.AnnotationNormal) {
            if (this._isEditingText) {
                return;
            }

            if (!e.ctrlKey) {
                switch (e.key.toLowerCase()) {
                    case 'b':
                        this.handleToolbarChanges(
                            Strings.drawToolCheckboxName,
                            null,
                            !this.state.isDrawing
                        );
                        break;

                    case 'u':
                        if (!this._isDrawingRectangle.value) {
                            this.handleToolbarChanges(Strings.drawRectangleToolCheckboxName);
                        } else {
                            this.handleToolbarChanges(Strings.drawEllipseToolCheckboxName);
                        }
                        break;

                    case 'c':
                        if (
                            this.props.user.details.role === UserRole.Admin ||
                            this.props.user.details.role === UserRole.Support ||
                            this.props.user.details.role === UserRole.Management ||
                            this.props.user.details.role === UserRole.Economist ||
                            this.props.user.details.role === UserRole.Seller ||
                            this.props.user.details.role === UserRole.PlanEditorAdmin ||
                            this.props.user.details.role === UserRole.PlanEditor
                        ) {
                            this.handleToolbarChanges(Strings.cropToolCheckboxName);
                        }
                        break;

                    default:
                        break;
                }

                switch (e.keyCode) {
                    case 221: // å
                        this.handleToolbarChanges(
                            Strings.strokeWidthToolChange,
                            this.state.strokeWidth - 1
                        );
                        break;
                    case 186: // ¨ the key right to å
                        this.handleToolbarChanges(
                            Strings.strokeWidthToolChange,
                            this.state.strokeWidth + 1
                        );
                        break;
                    default:
                        break;
                }
            }
        }

        if (e.ctrlKey && key === 's' && this.canSave()) {
            e.preventDefault();
            this.save();
            return;
        }

        if (e.ctrlKey && key === 'r') {
            fabric.restoreCanvasPosition(this._canvas);
            e.preventDefault();
            return;
        }

        if (e.ctrlKey && key === 'z') {
            fabric.undo(this._canvas, this._fabric);
            return;
        }

        if (e.ctrlKey && key === '+') {
            this.zoom(200);
            e.preventDefault();
            return;
        }

        if (e.ctrlKey && key === '-') {
            this.zoom(-200);
            e.preventDefault();
            return;
        }

        if (e.ctrlKey && key.toLowerCase() === 'c' && this._allowDuplication) {
            this._allowDuplication = false;
            event.preventDefault();
            fabric.duplicateObjects(
                this._fabric,
                this._canvas,
                this.setEditingTextState,
                this.props.type === AnnotationTypes.AnnotationTexts
            );
            return;
        }

        if (
            e.altKey &&
            (this.props.type === AnnotationTypes.AnnotationNormal ||
                this.props.type === AnnotationTypes.ExternalAnnotation ||
                this.props.type === AnnotationTypes.DeliveryAnnotation ||
                this.props.type === AnnotationTypes.ExternalDeliveryAnnotation)
        ) {
            if (!this._isColorPipette.value) {
                this.handleToolbarChanges(Strings.colorPipetteToolCheckboxName);
            }

            e.preventDefault();
            return;
        }

        if (!this._isEditingText && e.keyCode === 32 /* Space */) {
            fabric.onSpaceKey(this._canvas);
        }

        if (
            !e.altKey &&
            !e.ctrlKey &&
            this.props.type === AnnotationTypes.AnnotationTexts &&
            !this._isEditingText
        ) {
            if (
                (e.keyCode > 64 && e.keyCode < 91) ||
                e.keyCode === 221 ||
                e.keyCode === 222 ||
                e.keyCode === 192
            ) {
                let ref = document.getElementById(this.listId);
                let texts = [].concat(this.props.commonTexts).sort();

                let index;
                for (let i = 0; i < texts.length; i++) {
                    if (texts[i].toLowerCase()[0] === key) {
                        index = i;
                        break;
                    }
                }

                if (index !== undefined) {
                    if (index === 0) {
                        ref.scrollTop = 0;
                    } else {
                        let positionInPercent = index / texts.length;
                        let scrollPosition = ref.scrollHeight * positionInPercent;
                        ref.scrollTop = scrollPosition;
                    }
                }
            }
        }

        if (e.keyCode !== 46 || !this.state.isObjectSelected || this._isEditingText) {
            // Delete or object not selected
            return;
        }

        fabric.deleteObjects(this._canvas);
        this.handleDeselectedObject();
    }

    onKeyUp(e: any) {
        if (
            this.props.type === AnnotationTypes.AnnotationNormal ||
            this.props.type === AnnotationTypes.ExternalAnnotation ||
            this.props.type === AnnotationTypes.DeliveryAnnotation ||
            this.props.type === AnnotationTypes.ExternalDeliveryAnnotation
        ) {
            if (this._isColorPipette.value) {
                this.handleToolbarChanges(Strings.colorPipetteToolCheckboxName);
            }

            if (this._isEditingText) {
                return;
            }
        }

        if (e.key.toLowerCase() === 'c') {
            this._allowDuplication = true;
        }
    }

    render() {
        return (
            <Modal
                show={true}
                onHide={() => this.onHideModal()}
                bsSize="large"
                bsStyle="modal-fs"
                style={{ zIndex: 2000 }}
                className="annotation-modal"
                autoFocus={false}
                enforceFocus={false}
                backdrop={'static'}
            >
                <Modal.Header>
                    <Modal.Title>
                        {(this.props.type === AnnotationTypes.AnnotationNormal ||
                            this.props.type === AnnotationTypes.ExternalAnnotation ||
                            this.props.type === AnnotationTypes.DeliveryAnnotation ||
                            this.props.type === AnnotationTypes.ExternalDeliveryAnnotation) && [
                            Translate('order/plan/annotation-modal/title'),
                            this.props.address ? ' - ' + this.props.address : ''
                        ]}
                        {this.props.type === AnnotationTypes.AnnotationFloorCrop && [
                            Translate('order/plan/floor-annotation-modal/title'),
                            this.props.address ? ' - ' + this.props.address : ''
                        ]}
                        {this.props.type === AnnotationTypes.AnnotationTexts && [
                            Translate('order/plan/texts-annotation-modal/title'),
                            this.props.address ? ' - ' + this.props.address : ''
                        ]}
                    </Modal.Title>

                    {this.state.annotation &&
                        Features.hasFeature(Features.PlanAnnotateViewHistory, this.props.user) && (
                            <FormSelect
                                name="selectedStorey"
                                value={'-1'}
                                onChange={this.openImage}
                            >
                                <option value={'-1'}>
                                    {Translate('plan-annotation/modal/compare/selection-value')}
                                </option>
                                {this.state.annotation.revisions.map((r: any, index: number) => (
                                    <option key={'revision-' + index} value={index.toString()}>
                                        {r.name}
                                    </option>
                                ))}
                            </FormSelect>
                        )}

                    {this.state.annotation && this.props.changeFile && (
                        <FormSelect
                            name="selectedPlanOrderStoreyFile"
                            value={this.state.annotation.subject.id.toString()}
                            onChange={(e: any) => {
                                this.onPlanOrderStoreyFileChanged(e.target.value);
                            }}
                        >
                            {this.filterOutBlueprints(
                                this.props.type,
                                this.props.annotation.planOrderStoreyFiles
                            ).map((f: any, index: number) => (
                                <option key={'file-' + index} value={f.id.toString()}>
                                    {f.storeyName ? f.storeyName : f.customStoreyName} -{' '}
                                    {f.fileTypeName}
                                </option>
                            ))}
                        </FormSelect>
                    )}

                    {this.state.annotation &&
                        this.props.type === AnnotationTypes.AnnotationTexts &&
                        this.props.showFilePlacementsModal && (
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id="tooltip-placement">
                                        <p>
                                            {Translate(
                                                'order/plan/storey/annotate-placement-button'
                                            )}
                                        </p>
                                    </Tooltip>
                                }
                            >
                                <Button
                                    bsStyle="warning"
                                    className="place-btn"
                                    onClick={() =>
                                        this.onHideModal(() =>
                                            this.props.showFilePlacementsModal(
                                                this.state.annotation.subject.id
                                            )
                                        )
                                    }
                                >
                                    <i className="material-icons no-label">transform</i>
                                </Button>
                            </OverlayTrigger>
                        )}

                    {(this.props.extraInformation ||
                        (this.props.returnedMessages &&
                            this.props.returnedMessages.length > 0)) && (
                        <CustomerMessages
                            extraInformation={this.props.extraInformation}
                            returnedMessages={this.props.returnedMessages}
                        />
                    )}

                    <PlanAnnotationSaveReset
                        reset={this.reset}
                        save={() => this.save()}
                        canSave={this.canSave()}
                        isSaving={this.state.isSaving}
                    />

                    <Button className="close-x" bsStyle="link" onClick={() => this.onHideModal()}>
                        <i className="material-icons">close</i>
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {!this.state.annotation && (
                        <div className="canvas-save-spinner">
                            <Loader loaded={false} scale={2.0}></Loader>
                        </div>
                    )}
                    {this.state.annotation && (
                        <div>
                            <Row>
                                <Col sm={12}>
                                    {this._canvas && (
                                        <PlanAnnotationToolbar
                                            flipHorizontal={this.flipHorizontal}
                                            flipVertical={this.flipVertical}
                                            toggleGrid={this.toggleGrid}
                                            rotate={this.rotate}
                                            onChange={(e: any) =>
                                                this.handleToolbarChanges(
                                                    e.target.name,
                                                    e.target.value,
                                                    e.target.checked
                                                )
                                            }
                                            deleteObject={this.onToolbarDeleteObject}
                                            deleteAllObjectsExceptTexts={
                                                this.showDeleteAllObjectsExceptTextsConfirmation
                                            }
                                            onToolbarFontSizeChange={this.onToolbarFontSizeChange}
                                            isDrawing={this.state.isDrawing}
                                            isDrawingEllipse={this.state.isDrawingEllipse}
                                            isDrawingRectangle={this.state.isDrawingRectangle}
                                            isCropping={this.state.isCropping}
                                            crop={this.crop}
                                            comment={this.state.comment}
                                            storeys={this.props.storeys}
                                            storey={this.state.storey}
                                            customStorey={this.state.customStorey}
                                            storeyIsSelected={this.state.storeyIsSelected}
                                            isObjectSelected={this.state.isObjectSelected}
                                            fontSize={this.state.fontSize}
                                            type={this.props.type}
                                            strokeWidth={this.state.strokeWidth}
                                            strokeColor={this.state.strokeColor}
                                            onToolbarStrokeWidthChange={
                                                this.onToolbarStrokeWidthChange
                                            }
                                            onToolbarStrokeColorChange={
                                                this.onToolbarStrokeColorChange
                                            }
                                            showColorPicker={this.state.showColorPicker}
                                            onShowColorPickerChanged={this.onShowColorPickerChanged}
                                            isColorPipette={this.state.isColorPipette}
                                            isRotateFreely={this.state.isRotateFreely}
                                            isGridActive={this.state.isGridActive}
                                            user={this.props.user}
                                        />
                                    )}
                                    <div className="canvas-group">
                                        {(this.state.isSaving || this.state.isLoading) && (
                                            <div className="canvas-save-spinner">
                                                <Loader loaded={false} scale={2.0}></Loader>
                                            </div>
                                        )}
                                        {this._canvas &&
                                            (this.props.type === AnnotationTypes.AnnotationNormal ||
                                                this.props.type ===
                                                    AnnotationTypes.ExternalAnnotation ||
                                                this.props.type ===
                                                    AnnotationTypes.DeliveryAnnotation ||
                                                this.props.type ===
                                                    AnnotationTypes.ExternalDeliveryAnnotation) && (
                                                <PlanAnnotationDragSourcePanel
                                                    disabled={this.state.isRotateFreely}
                                                />
                                            )}
                                        {this._canvas &&
                                            this.props.type === AnnotationTypes.AnnotationTexts && (
                                                <PlanAnnotationTextPanel
                                                    commonTexts={this.props.commonTexts}
                                                    disabled={this.state.isRotateFreely}
                                                    listId={this.listId}
                                                />
                                            )}
                                        {this.state.annotation.subject && (
                                            <PlanAnnotationDisplay
                                                key={
                                                    this.state.canvasKey +
                                                    this.state.annotation.subject.id
                                                }
                                                canvasId={
                                                    this.canvasId + this.state.annotation.subject.id
                                                }
                                                setCanvasContainerReference={
                                                    this.setCanvasContainerReference
                                                }
                                                zoom={this.zoom}
                                                restoreCanvasPosition={this.restoreCanvasPosition}
                                            />
                                        )}
                                    </div>
                                </Col>
                            </Row>

                            {this.state.showCloseConfirmation && (
                                <ConfirmationModal
                                    title={Translate(
                                        'order/plan/annotation-modal/close/confirmation/title'
                                    )}
                                    text={Translate(
                                        'order/plan/annotation-modal/close/confirmation/text'
                                    )}
                                    doButtonLabel={Translate(
                                        'order/plan/annotation-modal/close/confirmation/do-button'
                                    )}
                                    doButtonStyle="danger"
                                    size={'lg'}
                                    do={() => this.save(this.state.saveCallback)}
                                    middleButtonLabel={Translate(
                                        'order/plan/annotation-modal/close/confirmation/cancel-without-save-button'
                                    )}
                                    middleButtonOnClick={() => {
                                        this.setState({
                                            showCloseConfirmation: false
                                        });
                                        this.state.saveCallback &&
                                        typeof this.state.saveCallback === 'function'
                                            ? this.state.saveCallback()
                                            : this.props.close();
                                    }}
                                    cancelButtonLabel={Translate(
                                        'order/plan/annotation-modal/close/confirmation/cancel-button'
                                    )}
                                    closeModal={() => {
                                        this.setState({
                                            showCloseConfirmation: false,
                                            saveCallback: null
                                        });
                                    }}
                                />
                            )}
                            {this.state.showDeleteAllObjectsExceptTextsConfirmation && (
                                <ConfirmationModal
                                    title={Translate(
                                        'order/plan/annotation-modal/delete-all-object-except-texts/confirmation/title'
                                    )}
                                    text={Translate(
                                        'order/plan/annotation-modal/delete-all-object-except-texts/confirmation/text'
                                    )}
                                    doButtonLabel={Translate(
                                        'order/plan/annotation-modal/delete-all-object-except-texts/confirmation/do-button'
                                    )}
                                    doButtonStyle="danger"
                                    do={this.onToolbarDeleteAllObjectsExceptTexts}
                                    cancelButtonLabel={Translate(
                                        'order/plan/annotation-modal/delete-all-object-except-texts/confirmation/cancel-button'
                                    )}
                                    closeModal={() => {
                                        this.setState({
                                            showDeleteAllObjectsExceptTextsConfirmation: false
                                        });
                                    }}
                                />
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => this.onHideModal()}>
                        {Translate('order/plan/annotation-modal/close-button')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default PlanAnnotationTool;
